import FormControl from "@material-ui/core/FormControl";
import { FieldTemplateProps } from "@rjsf/core";
import classNames from "classnames";
import React from "react";
import { Description, Error, Help, Label } from "../shared";

export const FieldTemplate = (props: FieldTemplateProps) => {
  const {
    id,
    classNames: className,
    readonly,
    label,
    required,
    rawHelp,
    rawDescription,
    rawErrors,
    hidden,
    schema,
    uiSchema,
    formContext,
    children,
  } = props;

  if (hidden) {
    return children;
  }

  let widgetOrFieldName = (uiSchema["ui:widget"] || uiSchema["ui:field"]) as string | undefined;
  if (widgetOrFieldName) {
    widgetOrFieldName = widgetOrFieldName.toLowerCase();
  }

  const isField = !!uiSchema["ui:field"];
  const isHiddenField = widgetOrFieldName && widgetOrFieldName.indexOf("hiddenfield") !== -1;
  const isReadOnlyWidgetOrField = widgetOrFieldName && widgetOrFieldName.indexOf("readonly") !== -1;
  const uiOptions: any = uiSchema["ui:options"];
  const allowHtml = uiOptions && uiOptions.allowHtml;

  const isReadOnlyDisplayFormat = readonly || formContext.readOnly || isReadOnlyWidgetOrField;

  // Hide the Label if there is no title to show
  const displayLabel =
    props.displayLabel &&
    schema.title &&
    !(
      widgetOrFieldName === "consentwidget" ||
      widgetOrFieldName === "checkboxwidget" ||
      widgetOrFieldName === "titlewidget"
    );
  const shrinkLabel = widgetOrFieldName
    ? !(
        widgetOrFieldName.indexOf("radio") === -1 &&
        widgetOrFieldName.indexOf("checkboxes") === -1 &&
        widgetOrFieldName.indexOf("richtexteditorwidget") === -1
      )
    : false;

  const errorsOverride =
    rawErrors && rawErrors.length && widgetOrFieldName && widgetOrFieldName.indexOf("consentwidget") === 0
      ? ["Acknowledgement is required."]
      : undefined;

  return (
    <FormControl
      margin={"normal"}
      fullWidth={true}
      className={classNames(className, isHiddenField && "field--hidden", !displayLabel && "field-label--hidden")}
      error={!(isField || isReadOnlyDisplayFormat) && rawErrors && rawErrors.length > 0}
    >
      {displayLabel && (
        <Label
          fieldId={id}
          required={required}
          label={label}
          labelOnly={isReadOnlyDisplayFormat}
          shrinkLabel={shrinkLabel}
          allowHtml={allowHtml}
        />
      )}
      {displayLabel && <Description fieldId={id} description={rawDescription} allowHtml={allowHtml} />}
      {children}
      {!(isField || isReadOnlyWidgetOrField) ? (
        <>
          <Error fieldId={id} errors={errorsOverride || rawErrors} allowHtml={allowHtml} />
          <Help fieldId={id} help={rawHelp} allowHtml={allowHtml} />
        </>
      ) : null}
    </FormControl>
  );
};
